__turbopack_context__.v({
  "externalIcon": "C0s_8a_externalIcon",
  "linkCard": "C0s_8a_linkCard",
  "linkDescription": "C0s_8a_linkDescription",
  "linkDetails": "C0s_8a_linkDetails",
  "linkTitle": "C0s_8a_linkTitle",
});
